import { UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { GetOrdersResponse, OrderSheetParameter, OrdersDetailResponse, api } from '@/apis';

import { useCoreMutation, useCoreQuery } from '../core';
import { keys } from '../keys';

interface UseOrderQueryDetailParameter {
  orderGroupNumber: string;
  loggedIn: boolean;
  phone?: number;
  options?: UseQueryOptions<OrdersDetailResponse, AxiosError>;
}

/**
 * 주문 그룹 리스트 조회
 * @returns
 */
export const useOrderGroupsQuery = (keyword?: string) =>
  useCoreQuery(keys.orders.orderGroups(keyword), () =>
    api.orders.orderGroups(keyword).then((res) => res),
  );

/**
 * 주문 그룹 상세 조회
 * @param orderGroupNumber
 * @returns
 */
export const useOrderGroupDetailQuery = ({
  orderGroupNumber,
  loggedIn,
  phone,
  options,
}: UseOrderQueryDetailParameter) =>
  useCoreQuery(
    keys.orders.get(orderGroupNumber),
    () => api.orders.get(orderGroupNumber, loggedIn, phone).then((res) => res),
    options,
  );

export const useOrderV1Query = ({
  orderGroupNumber,
  loggedIn,
  phone,
  options,
}: UseOrderQueryDetailParameter) =>
  useCoreQuery(
    keys.orders.getV1(orderGroupNumber),
    () => api.orders.getV1(orderGroupNumber, loggedIn, phone).then((res) => res),
    options,
  );

export const useOrderSheetMutation = (version?: string) =>
  useCoreMutation((parameters: OrderSheetParameter) =>
    api.orders.sheet(parameters, version as string),
  );

export const useOrdersQuery = (
  search: string,
  options?: UseQueryOptions<GetOrdersResponse, AxiosError>,
) =>
  useCoreQuery(keys.orders.list(search), () => api.orders.list(search).then((res) => res), options);
